<template>
	<div>
		<div class="row">
			<div class="col-md-12 mb-2">
				<h4>HRGA REPORT</h4>
			</div>

			<div class="col-md-12">
				<el-card shadow="never" class="box-card col-md-12 mb-4" :body-style="{ paddingLeft: '8px', paddingRight: '8px', paddingTop: '8px' }">
					<div slot="header" class="clearfix" v-if="false">
						<span><strong>HRGA REPORT</strong></span>
					</div>
					<div>
						<div class="mb-3">
							<el-tabs v-model="tabIndex" @tab-click="handleTabClick">
								<el-tab-pane :label="item.label" :name="item.index" v-for="(item, index) in tabList" :key="index" >
									<HrgaReportTab :tabIndex="item.index" :tabName="item.name" :tabLabel="item.label"/>
								</el-tab-pane>
							</el-tabs>
						</div>
					</div>
				</el-card>
			</div>
		</div>
	</div>
</template>

<script>
import Basic from '@/components/page/Basic.js'
import Footer from '@/views/Footer.vue'
import HrgaReportTab from '@/views/pages/HrgaReportTab.vue'

export default{
	extends: Basic,
	components:{
		HrgaReportTab,
	},
	data() {
		return {
			pldate: this.$route.query.pldate ? this.$route.query.pldate : null,
			tabIndex: this.$route.query.tab ? this.$route.query.tab : 0,
			tabList:[
				{label:'Pegawai TKJP', name: 'tkjp', index: '0' },
			],
		}
	},
    mounted(){
		this.$emit('childrenRoute');
    },
    methods:{
        handleTabClick(tab, event) {
            let tabIndex = tab.$vnode.key
            let tabName = tab.name
            let tabLabel = tab.label
			/*
            this.tab.index = tabIndex
            this.tab.name = tabName
            this.tab.label = tabLabel
			*/
        },
	}
}

</script>
